/**
 * Value formatting for dashboard widgets, keyed by the metric `format` the
 * backend registry returns ('number' | 'percent' | 'rate' | 'days').
 *
 * Mirrors the compact style of components/oim/KpiCard so the framework reads
 * consistently with existing cards. Null/NaN render as an em-dash.
 */

function compact(n, maxFractionDigits) {
  return n.toLocaleString(undefined, { maximumFractionDigits: maxFractionDigits });
}

export function formatMetricValue(value, format = 'number') {
  if (value === null || value === undefined) return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return '—';

  switch (format) {
    case 'percent':
      return `${compact(n, n % 1 === 0 ? 0 : 1)}%`;
    case 'rate':
      return compact(n, 2);
    case 'days':
      return compact(n, 1);
    case 'number':
    default: {
      const abs = Math.abs(n);
      return compact(n, abs >= 1000 ? 0 : abs >= 10 ? 1 : 2);
    }
  }
}

/**
 * The unit string to render beside the value. `percent` bakes the "%" into
 * the formatted value, so its unit is empty to avoid "87.5%%".
 */
export function unitForMetric(metric) {
  if (!metric) return '';
  if (metric.format === 'percent') return '';
  if (metric.format === 'days') return metric.unit || 'days';
  return metric.unit || '';
}
